export default "__VITE_ASSET__DfexXDVV__"